import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CdTimerModule} from 'angular-cd-timer';
import {FbAuctionCardComponent} from './fb-auction-card.component';
import { FbAuctionDetailService } from '../../fb-auction-detail/fb-auction-detail.service';

@NgModule({
    imports: [
        CommonModule,
        CdTimerModule
    ],
    declarations: [FbAuctionCardComponent],
    exports: [FbAuctionCardComponent],
    providers: [FbAuctionDetailService]
})
export class FbAuctionCardModule {
}
